<template>
    <div class="maincontainer">
        <taskform v-if="role != 'ddd_customer'" :ntask="ntask"  :loaded="loaded" v-on:saveTask="saveTaskClicked" :customers="customersList" :workerItems="workerItems" :workersLoaded="workersLoaded"></taskform>
        <table>
            <thead>
                <tr>
                    <th style="width: 5%;" v-on:click="set_order('customer_number')" class="cursor-pointer">
                        <span>{{$t('customers.number')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'customer_number' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'customer_number' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                            <input id="name" type="text" class="validate" v-model="numbersearch">
                        </div>
                    </th>
                    <th style="width: 25%;" v-on:click="set_order('name')" class="cursor-pointer">
                        <span>{{$t('places.name')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'name' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'name' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                            <input id="name" type="text" class="validate" v-model="namesearch">
                        </div>
                    </th>
                    <th style="text-align: center;" v-for="devc in devcats" :title="devc.name" class="cursor-pointer">
                        {{devc.prefix}}
                    </th>
                    <th v-on:click="set_order('last_inspected')" class="cursor-pointer">
                        <span> {{$t('places.last_inspection')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'last_inspected' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'last_inspected' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                        </div>
                    </th>
                    <th v-on:click="set_order('next_inspection')" class="cursor-pointer">
                        <span> {{$t('places.planned_next_inspection')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'next_inspection' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'next_inspection' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                        </div>
                    </th>
                    <th style="width: 15%;" v-on:click="set_order('status')" class="cursor-pointer">
                        <span>{{$t('customers.status')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'status' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'status' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s12">
                            <select multiple="true" v-model="status">
                                <option value="" disabled selected>Status</option>
                                <option value="active">{{$t('places.active')}}</option>
                                <option value="inactive">{{$t('places.inactive')}}</option>
                                <option value="suspended">{{$t('places.suspended')}}</option>
                            </select>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="loaded">
                <template v-for="(place, index) in listItems">
                    <tr :class="place.status == 'active' ? '' : 'grayed'" >
                        <td>{{place.customer_number}}</td>
                        <td>
                            <router-link :to="{ name: 'place', params: { customer_id: place.customer_id, place_id: place.id }}">
                                {{!!place.name ? place.name :  $t('places.no_name')  }}
                            </router-link>
                        </td>
                        <td v-for="devc in devcats" style="text-align: center; padding-left: 5px;"><template v-if="place.countgroups[devc.id] != undefined">{{place.countgroups[devc.id].quantity}}</template><template v-if="place.countgroups[devc.id] == undefined">0</template></td>
                        <td>
                            <div>{{place.last_inspected * 1000 | formatDate}}</div>
                        </td>
                        <td>
                            <div class="cursor-pointer" v-if="place.next_inspection"  v-bind:class="{ 'overdue': place.overdone }" v-on:click="showTask(place.next_inspection_task)">{{place.next_inspection * 1000 | formatDate}}</div>
                            <div v-else-if="place.status == 'active' && role != 'ddd_customer'"><button class="btn btn-small green" v-on:click="planInspection(place)">{{$t('menu.buttons.plan_inspection')}}</button></div>
                        </td>
                        <td style="text-transform: uppercase;">{{place.status == "active" ? $t('places.active') : $t('places.inactive')}}</td>
                    </tr>
                </template>
            </tbody>
            <preloader v-if="loaded == false" :n="5 + devcats.length" />
        </table>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';
export default {
    data: function() {
        return {
            order: 'asc',
            orderby: 'number',
            places: [],
            loaded: false,
            namesearch: "",
            addressearch: "",
            numbersearch: "",
            status: ['active'],
            devcats: [],
            workerItems: [],
            workersLoaded: false,
            selectedTags: [],
            placesDict: {},
            workers: [],
            lastInspectiondateRange: { 
              startDate: moment().startOf('year').format(),
              endDate: moment().endOf('year').format()
            },
            nextInspectiondateRange: { 
              startDate: moment().startOf('year').format(),
              endDate: moment().endOf('year').format()
            },
            ntask: undefined
        }
    },
    props: { role: String },
    created() {
        this.fetch_places();
    },
    methods: {
        fetch_places: async function() {
            var response = await axios.get('/places.json')
            this.places = response.data;
            for (var i in this.places) {
                this.places[i].collapsed = false;
                this.places[i].address_text =  "" + this.places[i].address.street + ""
                var place = this.places[i];
                place.orders_groupped = _.keyBy(place.orders, 'dev_type_id');
                this.places[i].countgroups = _.keyBy(this.places[i].counts, 'device_category');
                if(moment(this.places[i].next_inspection * 1000).isSameOrAfter(moment(), 'day')){
                    this.places[i].overdone = false
                }else{
                    this.places[i].overdone = true
                }
            }
            this.placesDict = _.keyBy(this.places, 'id');
            response = await axios.get('/device_categories.json');
            this.devcats = response.data;
            if(this.role != "ddd_customer"){
            response = await axios.get('/workers.json')
                this.workers = response.data;
                for (var i in this.workers) {
                    var item = this.workers[i];
                    if (item.active == true) {
                        this.workerItems.push({ value: item.id, name: item.name + " " + item.surname, symbol: item.symbol });
                    }
                }
            }
            this.loaded = true;
            this.workersLoaded = true;
            this.init_selectors();
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
         saveTaskClicked: async function(task) {
           
            await this.saveTask(task)
            if (this.instances != undefined) {
                if(!_.isUndefined(this.instances[0])) this.instances[0].close()
            }
        },
        saveTask: async function(task) {
            if (task != null) {
                this.ntask = task;
            }
            if(moment(this.ntask.startsAt).isAfter(this.ntask.endsAt)){
                return false;
            } 
            const formData = new FormData();
            formData.append('task[startsAt]', moment(this.ntask.startsAt).utcOffset(1, false).format('YYYY-MM-DDTHH:mmZZ'));
            formData.append('task[endsAt]', moment(this.ntask.endsAt).utcOffset(1, false).format('YYYY-MM-DDTHH:mmZZ'));
            formData.append('task[typeof]', this.ntask.typeof);
            formData.append('task[payment_method]', this.ntask.payment_method || "cash");
            formData.append('task[pricing]', this.ntask.pricing);
            if (this.ntask.routine) formData.append('task[routine]', true);
            formData.append('task[name]', this.ntask.name);
            formData.append('task[status]', this.ntask.status);
            formData.append('task[reconescance]', this.ntask.reconescance);
            formData.append('task[physical_mount]', this.ntask.physical_mount);
            formData.append('task[intervention_type_other]', this.ntask.intervention_type_other);
            formData.append('task[typeof_other]', this.ntask.typeof_other);
            if (_.isUndefined(this.ntask.worker_ids) == false) {
                for (var index in _.range(0, this.ntask.worker_ids.length)) {
                    var worker_id = this.ntask.worker_ids[index];
                    if(worker_id != -1){
                        formData.append('task[worker_ids][]', worker_id);
                    }
                }
            }
            if (_.isUndefined(this.ntask.photos) == false) {
                for (var index in _.range(0, this.ntask.photos.length)) {
                    formData.append('task[media_attributes][' + index + '][image]', this.ntask.photos[index].attachment);
                    if (this.ntask.photos[index].id) {
                        formData.append('task[media_attributes][' + index + '][id]', this.ntask.photos[index].id);
                    }
                    if (this.ntask.photos[index].destroy) {
                        formData.append('task[media_attributes][' + index + '][_destroy]', true);
                    }
                }
            }
            if (this.ntask.typeof == 'intervention') formData.append('task[intervention_type]', this.ntask.intervention_type);
            if(_.isUndefined(this.ntask.phone_number) == false){
                formData.append('task[phone_number]', this.ntask.phone_number);
            }
            if (this.ntask.routine == false && (this.ntask.typeof == 'other' || this.ntask.typeof == 'intervention')) {
                formData.append('task[address_attributes][name]', this.ntask.address.name);
                formData.append('task[address_attributes][street]', this.ntask.address.street);
                formData.append('task[address_attributes][city]', this.ntask.address.city);
                formData.append('task[address_attributes][postal_code]', this.ntask.address.postal_code);
            } else {
                formData.append('task[place_id]', this.ntask.place_id);
            }
            if (this.ntask.id) {
                var response = await axios.put('/tasks/' + this.ntask.id + '.json', formData)
                var task = _.cloneDeep(response.data)
                this.tasks.splice(this.tasks.indexOf(_.find(this.tasks, { id: this.ntask.id })), 1)
            } else {
                var response = await axios.post('/tasks.json', formData)
                var task = _.cloneDeep(response.data)   
            }
            task.startsAt = moment(task.startsAt).format('YYYY-MM-DDTHH:mm')
            task.endsAt = moment(task.endsAt).format('YYYY-MM-DDTHH:mm')
            this.placesDict[task.place_id].next_inspection = moment(task.startsAt).unix()
            this.ntask = null

        },
        init_selectors: function() {
            var elems = document.querySelectorAll('select');
            var instances = M.FormSelect.init(elems, {});
        },
        planInspection: function(place){
            this.ntask = {
                typeof: 'inspection',
                status: 'no_date',
                place_id: place.id,
                routine: false,
                worker_ids: [],
                startsAt: moment().format('YYYY-MM-DDTHH:mm'),
                endsAt: moment().add(1, 'hour').format('YYYY-MM-DDTHH:mm'),
                address: {
                    name: "",
                    street: "",
                    city: "",
                    postal_code: ""
                },
                phone_number: "",
                reconescance: "",
                photos: [],
                edit: true
            };
            var elems = document.querySelectorAll('.modal');
            this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, });
            if(!_.isUndefined(this.instances[0])) this.instances[0].open()
        },
         showTask: async function(taskid){
          var resp = await axios.get("/tasks/"+taskid+".json")
          this.ntask = resp.data
          var elems = document.querySelectorAll('.modal');
          this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, });
          if(!_.isUndefined(this.instances[0])) this.instances[0].open()
        },
    },
    computed: {
        listItems() {
            var that = this;
            const range = moment.range(
                moment(this.lastInspectiondateRange.startDate),
                moment(this.lastInspectiondateRange.endDate)
            );
            const next_range = moment.range(
                moment(this.nextInspectiondateRange.startDate),
                moment(this.nextInspectiondateRange.endDate)
            );
            return _.filter(
                _.orderBy(this.places, this.orderby, this.order),
                function(item) {
                    return (_.includes(that.status, item.status) || that.status.length == 0) && (_.intersection(that.selectedTags, item.tags).length > 0 || that.selectedTags.length == 0) && (item.name.toUpperCase().indexOf(that.namesearch.toUpperCase()) >= 0) 
                        && (item.customer_number.toUpperCase().indexOf(that.numbersearch.toUpperCase()) >= 0)
                        && (item.address_text != null && item.address_text.toUpperCase().indexOf(that.addressearch.toUpperCase()) >= 0)
                }
            );
        },
        customersList() {
            var groupos = _.groupBy(this.places, 'customer_id');
            var items = []
            for( var group_id in groupos){
                items.push({"id": group_id, "name": _.first(groupos[group_id]).customer_name, "status": "active", "places": groupos[group_id]})
            }
            return items;
        },
        overdone(){
            return function(datetime){
                return moment(datetime).unix() < moment().unix(); 
            }   
        }
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

.selectorignored select {
    display: block;
}

.maincontainer {
    margin: 33px;
}

thead {
    background-color: #DADADA;
}

thead th {
    font-weight: 300;
    padding-top: 5px;
    padding-bottom: 5px;
}

th span {
    padding-left: 5px;
}

td {
    padding-left: 15px;
}

thead .input-field {
    margin-top: unset;
    margin-bottom: unset;
}

/deep/ div.select-wrapper {
    color: red;
    margin-left: 0px !important;
}

a {
    color: black;
}

/deep/ .vue-daterange-picker>div {
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    border-radius: 5px;
    margin-bottom: 8px;
}

/deep/ .reportrange-text {
    padding-left: 5px !important;
    padding-top: 7px !important;
    padding-bottom: 7px !important;
}
.grayed {
    color: #BEBBBB !important;
}
.grayed a{
    color: #BEBBBB !important;
}
.overdue {
    color: red;
}
</style>